import { unwrap } from "@majourneys/api-client";
import { api } from "../../../lib/api";
import type { ActivityFilters } from "../constants/query-keys";

export const activitiesApi = {
  list: async (filters: ActivityFilters) =>
    unwrap(await api.activities.explore.search.get({ query: filters })),

  getBySlug: async (slug: string, lang?: string) =>
    unwrap(await api.activities.explore({ slug }).get({ query: lang ? { lang } : {} })),

  availability: async (slug: string, date: string) =>
    unwrap(await api.activities.explore({ slug }).times.get({ query: { date } })),

  /**
   * Put the account's heart where the guest asked, saved or not. Safe to
   * repeat, unlike the toggle: a browser that misread the list can no longer
   * delete a save by tapping what looked like an empty heart.
   */
  setWishlist: async (slug: string, saved: boolean) =>
    unwrap(await api.activities.explore({ slug }).wishlist.post({ saved })),

  listCategories: async (city?: string, lang?: string) =>
    unwrap(
      await api.categories.explore.get({
        query: { ...(city ? { city } : {}), ...(lang ? { lang } : {}) },
      }),
    ),

  listCities: async (lang?: string) =>
    unwrap(await api.cities.explore.get({ query: lang ? { lang } : {} })),
};
